/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
import { gsap } from "gsap";
/* eslint-disable no-console */
console.log( 'Hello World! (from create-block-hr-brand block)' );
/* eslint-enable no-console */
gsap.to("#paint0_linear_3785_51139", {
	duration: 6,
	repeat: -1,
	repeatDelay: 1,
	ease: "power1.inOut",
	yoyo: true,
	keyframes: [
		{
			attr: { x1: 48, y1: 74, x2: 480, y2: 290 },
			color: "#702FDE",
			duration: 2000
		},
		{
			attr: { x1: 828, y1: 74, x2: 480, y2: 290 },
			color: "#10C4F2",
			duration: 2000
		},
		{
			attr: { x1: 828, y1: 450, x2: 480, y2: 290 },
			color: "#19FFA0",
			duration: 2000
		},
		{
			attr: { x1: 48, y1: 450, x2: 480, y2: 290 },
			color: "#F7F746",
			duration: 2000
		}
	]
});



